import { getDatumZ } from "building-generation/elements/datums";
import type { Building } from "building-types/building/buildingTypes";
import type { ResolvedDatumTable } from "building-types/datums/datumsTypes";
import type { ForeignEntityId } from "building-types/handles/foreignEntityId";
import type { Level } from "building-types/levels/levelTypes";

/**
 * Resolves the world-Z elevation of a freeform floor top from resolved datum settings.
 */
export function resolveFreeformFloorTopWorldZ(
  level: Level,
  resolvedDatums: ResolvedDatumTable,
  topDatum?: ForeignEntityId<"DATUM">,
  datumOffset = 0,
): number {
  if (topDatum && resolvedDatums[topDatum]) {
    return getDatumZ(resolvedDatums[topDatum]) + datumOffset;
  }
  return level.floorElevation + datumOffset;
}

/**
 * Resolves the world-Z elevation of a freeform floor top from floor and floor-system settings.
 */
export function resolveFreeformFloorTopZ(
  floor: Building["doc"]["floors"][string] | undefined,
  floorSystems: Building["doc"]["floorSystems"],
  level: Level,
  resolvedDatums: ResolvedDatumTable,
): number {
  const floorSystem = floor ? floorSystems[floor.parentId] : undefined;
  const topDatum = floor?.topDatum ?? floorSystem?.topDatum;
  const floorTopDatumOffset = floor && "topDatumOffset" in floor ? floor.topDatumOffset : undefined;
  const datumOffset = floorTopDatumOffset ?? 0;
  return resolveFreeformFloorTopWorldZ(level, resolvedDatums, topDatum, datumOffset);
}
